import { composeIO } from 'react-compose-io'
import { fieldsAritmeticaTransformacaoApiIO } from './FieldsAritmeticaTransformacaoApi.IO'
import { FieldsAritmeticaTransformacaoApiView } from './FieldsAritmeticaTransformacaoApi.View'

export const FieldsAritmeticaTransformacaoApi = composeIO(FieldsAritmeticaTransformacaoApiView, fieldsAritmeticaTransformacaoApiIO)
